import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAATUlEQVR42n2NMQqAMBTFev87OTmIoEOHCiIdPIAgiIP+5484aRczZAok8I/CY992lDKKIxoy1zSD6RMsK1b3WBOxqkVdguN8gwL3YnEDEHh8OJs+1F8AAAAASUVORK5CYII="};
